import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import type { ShortCode } from "@/features/sub-families/types";
import { getRequestBuilder } from "@/lib/fetcher.ts";
import type { Locale, Nullable, SiteEnum } from "@/types";

export default async function getShortCode(smartNumber: Nullable<string>, site: SiteEnum, locale: Locale) {
    if (!smartNumber) throw new Error("Missing smartnumber!");

    DiagnosticsStore.collectEventLog("info", `Fetching short code for smart number: ${smartNumber}`);

    const response = await fetchShortCode(smartNumber, site, locale);

    if (!response.success) {
        DiagnosticsStore.collectEventLog("error", `Failed fetching short code for smart number: ${smartNumber}`);

        throw new Error(response.message ?? "Failed fetching short code");
    }

    return response;
}

function fetchShortCode(smartNumber: string, site: SiteEnum, locale: Locale) {
    const requester = getRequestBuilder(site, locale);

    return requester<ApiSuccess, ApiError>("/catalog/shortcode/resolve/", { input: smartNumber });
}

type ApiSuccess = {
    smartnumber: string;
    shortcode: ShortCode;
    resolvedFromShortcode: boolean;
};

type ApiError = { exception: string; message: string };
